import styled from "styled-components";

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;
export const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 800px;

    h2 {
        margin: 2rem;
    }
`;
export const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
    
    input {
        width: 90%;
        margin: 1rem;
        padding: 1.5rem;
        border: none;
        background: #fff;
        border-radius: 20px;
    }
    
    .title-box {
        width: 100%;
    }
    .title {
        margin-left: 1.2rem;
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    border: none;
    color: white;
    font-family: Inter;
    font-weight: bold;
    font-size: large;
    background-color: black;
    padding: 1rem 1rem;
    border-radius: 20px;
`;

export const Alert = styled.div``;